(function (module) {
    'use strict';
    module.factory('constants', [
        function () {
            var exports = {};
            exports.WIDGET_EXPORT_TIMEOUT = 85000;
            return exports;
        }
    ]);
})(angular.module('reporting.dashboards.services'));
